import React, { useContext } from 'react';
import { TenantListItem } from '.';
import { SuiteHeaderContext } from '../SuiteHeaderProvider';
import { ITenantProps } from './ITenantProps';
import { TenantGroup } from './TenantGroup/TenantGroup';

interface ICurrentTenantProps {
  readonly currentOrg: ITenantProps | undefined;
  readonly switchTenant: (target: ITenantProps) => void;
}

const defaultOrg: ITenantProps = {
  displayName: '',
  tenantId: ''
};

export const CurrentTenant: React.FC<ICurrentTenantProps> = ({ currentOrg, switchTenant }) => {
  const { localizationMap } = useContext(SuiteHeaderContext);
  const { currentOrganizationTitle } = localizationMap;
  return (
    <TenantGroup name={currentOrganizationTitle}>
      <TenantListItem
        key={currentOrg?.tenantId || ''}
        item={currentOrg || defaultOrg}
        changeTenant={switchTenant}
        isCurrentOrg={true}
      />
    </TenantGroup>
  );
};
